// src/locales/manage-vi.ts
export default {
  manage: {
    dashboard: {
      title: "Tổng quan",
      subtitle: "Theo dõi các thông số và hoạt động quan trọng",
      protectionScore: "Điểm bảo vệ",
      activeLicenses: "Giấy phép hoạt động",
      currentViolations: "Vi phạm hiện tại",
      monthlyRevenue: "Doanh thu tháng này",
      revenueChart: "Biểu đồ doanh thu",
      recentViolations: "Vi phạm gần đây",
      viewAll: "Xem tất cả",
      protectionMeasures: "Biện pháp bảo vệ",
      active: "Hoạt động",
      inactive: "Chưa kích hoạt",
      expiringContracts: "Hợp đồng sắp hết hạn",
      days: "ngày"
    },

    catalog: {
      title: "Quản lý danh mục tác phẩm",
      createNew: "Đăng ký tác phẩm mới",
      search: "Tìm kiếm tác phẩm...",
      filter: "Lọc",
      apply: "Áp dụng",
      sortBy: "Sắp xếp theo",
      showing: "Hiển thị",
      of: "trong",
      items: "mục",
      noWorks: "Không có tác phẩm nào",
      createWorkMessage: "Hãy đăng ký tác phẩm mới hoặc thay đổi bộ lọc.",
      deleteConfirmation: "Xác nhận xóa tác phẩm",
      deleteWarning: "Thao tác này không thể hoàn tác. Tất cả thông tin liên quan đến tác phẩm này sẽ bị xóa vĩnh viễn.",
      confirmDelete: "Xác nhận xóa",
      cancel: "Hủy bỏ",
      processing: "Đang xử lý...",

      filters: {
        contentKind: "Loại tác phẩm",
        allTypes: "Tất cả loại",
        image: "Hình ảnh",
        audio: "Âm thanh",
        video: "Video",
        text: "Văn bản",
        status: "Trạng thái",
        allStatuses: "Tất cả trạng thái",
        approved: "Đã duyệt",
        pending: "Chờ duyệt",
        rejected: "Từ chối",
        draft: "Bản nháp",
        other: "Khác"
      },

      sort: {
        title: "Tên tác phẩm",
        registrationDate: "Ngày đăng ký",
        licenseCount: "Số giấy phép",
        viewCount: "Lượt xem",
        protectionScore: "Điểm bảo vệ"
      },

      view: {
        grid: "Dạng lưới",
        list: "Dạng danh sách"
      },

      details: {
        registration: "Đăng ký",
        protection: "Bảo vệ",
        licenses: "giấy phép",
        views: "lượt xem",
        actions: {
          view: "Xem",
          edit: "Sửa",
          delete: "Xóa"
        }
      }
    },

    contracts: {
      title: "Quản lý hợp đồng",
      subtitle: "Gia hạn, sửa đổi hoặc hủy các hợp đồng cấp phép bản quyền",
      createNew: "Tạo hợp đồng mới",

      tabs: {
        active: "Đang hoạt động",
        pending: "Chờ phê duyệt",
        all: "Tất cả hợp đồng"
      },

      table: {
        contractId: "Mã hợp đồng",
        work: "Tác phẩm",
        owner: "Chủ sở hữu",
        licenseType: "Loại giấy phép",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        remainingTime: "Thời hạn còn lại",
        value: "Giá trị",
        status: "Trạng thái",
        actions: "Thao tác"
      },

      status: {
        active: "Đang hoạt động",
        pendingApproval: "Chờ phê duyệt",
        completed: "Hoàn thành",
        cancelled: "Đã hủy",
        unknown: "Không xác định"
      },

      actions: {
        edit: "Sửa",
        renew: "Gia hạn",
        cancel: "Hủy",
        approve: "Phê duyệt",
        reject: "Từ chối",
        view: "Xem"
      },

      days: "ngày",
      noActiveContracts: "Không có hợp đồng nào đang hoạt động",
      noPendingContracts: "Không có hợp đồng nào đang chờ phê duyệt",
      noContracts: "Không có hợp đồng nào",

      modal: {
        editTitle: "Sửa hợp đồng",
        renewTitle: "Gia hạn hợp đồng",
        cancelTitle: "Hủy hợp đồng",
        warning: "Cảnh báo!",
        cancelWarning: "Bạn đang chuẩn bị hủy hợp đồng",
        forWork: "cho tác phẩm",
        cancelWarningText: "Hành động này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục?",

        form: {
          contractId: "Mã hợp đồng",
          work: "Tác phẩm",
          startDate: "Ngày bắt đầu",
          endDate: "Ngày kết thúc",
          licenseType: "Loại giấy phép",
          usage: "Mục đích sử dụng",
          value: "Giá trị hợp đồng",
          cancelReason: "Lý do hủy",
          update: "Cập nhật",
          renew: "Gia hạn",
          confirmCancel: "Xác nhận hủy",
          cancel: "Hủy bỏ"
        },

        licenseTypes: {
          standard: "Tiêu chuẩn",
          premium: "Cao cấp",
          extended: "Mở rộng"
        },

        usageTypes: {
          commercial: "Thương mại",
          marketing: "Marketing",
          editorial: "Biên tập",
          personal: "Cá nhân"
        }
      }
    },

    payments: {
      title: "Thanh toán phí bản quyền",
      subtitle: "Quản lý và theo dõi các khoản thanh toán cho giấy phép bản quyền",
      search: "Tìm kiếm theo tên tác phẩm, mã giấy phép...",
      filter: "Lọc",
      export: "Xuất",

      filters: {
        allStatuses: "Tất cả trạng thái",
        completed: "Hoàn thành",
        pending: "Đang xử lý",
        failed: "Thất bại"
      },

      table: {
        paymentId: "Mã thanh toán",
        work: "Tác phẩm",
        licenseId: "Mã giấy phép",
        amount: "Số tiền",
        method: "Phương thức",
        date: "Ngày",
        status: "Trạng thái",
        actions: "Thao tác"
      },

      status: {
        completed: "Hoàn thành",
        pending: "Đang xử lý",
        failed: "Thất bại",
        unknown: "Không xác định"
      },

      methods: {
        bank_transfer: "Chuyển khoản ngân hàng",
        credit_card: "Thẻ tín dụng",
        e_wallet: "Ví điện tử",
        other: "Khác"
      },

      actions: {
        viewInvoice: "Xem hóa đơn",
        downloadInvoice: "Tải hóa đơn"
      },

      summary: {
        title: "Tổng kết thanh toán",
        totalPayments: "Tổng thanh toán",
        successfulPayments: "Thanh toán thành công",
        pendingPayments: "Đang xử lý"
      },

      noPaymentsFound: "Không tìm thấy dữ liệu thanh toán nào"
    },

    violations: {
      title: "Vi Phạm Pháp Lý",
      subtitle: "Quản lý và xử lý các vi phạm bản quyền",
      search: "Tìm kiếm theo tiêu đề tác phẩm, chủ sở hữu hoặc người vi phạm...",

      filters: {
        allStatuses: "Tất cả trạng thái",
        detected: "Đã phát hiện",
        notified: "Đã thông báo",
        underReview: "Đang xem xét",
        confirmed: "Đã xác nhận",
        rejected: "Đã bác bỏ",
        legalAction: "Đang xử lý pháp lý"
      },

      table: {
        work: "Tác phẩm",
        platform: "Nền tảng",
        violationType: "Loại vi phạm",
        violator: "Người vi phạm",
        detectionTime: "Thời gian phát hiện",
        severity: "Mức độ",
        status: "Trạng thái",
        actions: "Hành động"
      },

      severity: {
        critical: "Nghiêm trọng",
        high: "Cao",
        medium: "Trung bình",
        low: "Thấp"
      },

      status: {
        detected: "Đã phát hiện",
        notified: "Đã thông báo",
        underReview: "Đang xem xét",
        confirmed: "Đã xác nhận",
        rejected: "Đã bác bỏ",
        legalAction: "Đang xử lý pháp lý"
      },

      violationTypes: {
        unauthorized_usage: "Sử dụng trái phép",
        deepfake: "Deepfake",
        impersonation: "Mạo danh",
        contract_violation: "Vi phạm hợp đồng",
        other: "Khác"
      },

      actions: {
        view: "Xem",
        confirm: "Xác nhận vi phạm",
        reject: "Bác bỏ vi phạm",
        legalAction: "Chuyển sang xử lý pháp lý"
      },

      modal: {
        title: "Chi tiết báo cáo vi phạm #{{id}}",
        violationId: "Mã vi phạm",
        status: "Trạng thái",
        violatedWork: "Tác phẩm bị vi phạm",
        owner: "Chủ sở hữu",
        platform: "Nền tảng",
        violationType: "Loại vi phạm",
        severity: "Mức độ nghiêm trọng",
        detectionTime: "Thời gian phát hiện",
        violationUrl: "URL vi phạm",
        violator: "Người vi phạm",
        evidence: "Bằng chứng",
        actions: "Hành động đã thực hiện",
        noActionsRecorded: "Chưa có hành động nào được ghi nhận",
        close: "Đóng"
      },

      noViolationsFound: "Không tìm thấy vi phạm nào"
    },

    legalEnforcement: {
      title: "Thực Thi Pháp Lý",
      subtitle: "Quản lý các hành động pháp lý để bảo vệ quyền sở hữu trí tuệ",
      createNew: "Tạo hành động mới",
      search: "Tìm kiếm theo tiêu đề, mã vụ việc hoặc tên các bên...",

      filters: {
        allStatuses: "Tất cả trạng thái",
        planned: "Lên kế hoạch",
        inProgress: "Đang tiến hành",
        completed: "Hoàn thành",
        cancelled: "Đã hủy"
      },

      table: {
        caseId: "Mã vụ việc",
        title: "Tiêu đề",
        actionType: "Loại hành động",
        parties: "Các bên liên quan",
        executionDate: "Ngày thực hiện",
        priority: "Độ ưu tiên",
        status: "Trạng thái",
        actions: "Hành động"
      },

      status: {
        planned: "Lên kế hoạch",
        inProgress: "Đang tiến hành",
        completed: "Hoàn thành",
        cancelled: "Đã hủy"
      },

      priority: {
        urgent: "Khẩn cấp",
        high: "Cao",
        medium: "Trung bình",
        low: "Thấp"
      },

      actionTypes: {
        warning: "Cảnh báo pháp lý",
        dmca: "DMCA Takedown",
        lawsuit: "Khởi kiện",
        settlement_offer: "Đề xuất thỏa thuận",
        other: "Khác"
      },

      actions: {
        view: "Xem",
        documents: "Tài liệu",
        start: "Bắt đầu thực hiện"
      },

      modal: {
        title: "Chi tiết hành động pháp lý",
        tabs: {
          details: "Chi tiết",
          documents: "Tài liệu",
          history: "Lịch sử"
        },
        caseId: "Mã vụ việc",
        status: "Trạng thái",
        plaintiff: "Nguyên đơn",
        defendant: "Bị đơn",
        actionType: "Loại hành động",
        executionDate: "Ngày thực hiện",
        completionDate: "Ngày hoàn thành",
        priority: "Mức độ ưu tiên",
        assignedTo: "Người phụ trách",
        linkedTo: "Liên kết với",
        violation: "Vi phạm",
        dispute: "Tranh chấp",
        description: "Mô tả",
        documents: {
          title: "Tài liệu",
          addDocument: "Thêm tài liệu",
          noDocuments: "Không có tài liệu nào"
        },
        history: {
          title: "Lịch sử hành động",
          noActivities: "Chưa có hoạt động nào được ghi nhận",
          createAction: "Tạo hành động pháp lý",
          prepareDocuments: "Chuẩn bị và gửi tài liệu",
          completeAction: "Hoàn thành hành động"
        },
        close: "Đóng",
        startExecution: "Bắt đầu thực hiện",
        markComplete: "Đánh dấu hoàn thành"
      },

      noActionsFound: "Không tìm thấy hành động pháp lý nào"
    },

    disputes: {
      title: "Tranh Chấp Pháp Lý",
      subtitle: "Quản lý và xử lý các tranh chấp liên quan đến bản quyền",
      createNew: "Tạo tranh chấp mới",
      search: "Tìm kiếm theo tiêu đề, số hồ sơ hoặc tên các bên...",

      filters: {
        allStatuses: "Tất cả trạng thái",
        pending: "Chờ xử lý",
        active: "Đang xử lý",
        resolved: "Đã giải quyết",
        cancelled: "Đã hủy",
        appealed: "Đang kháng cáo"
      },

      table: {
        caseNumber: "Mã hồ sơ",
        title: "Tiêu đề",
        parties: "Các bên liên quan",
        disputeType: "Loại tranh chấp",
        startDate: "Ngày bắt đầu",
        priority: "Độ ưu tiên",
        status: "Trạng thái",
        actions: "Hành động"
      },

      disputeTypes: {
        copyright_dispute: "Vi phạm bản quyền",
        contract_violation: "Vi phạm hợp đồng",
        other: "Khác"
      },

      status: {
        pending: "Chờ xử lý",
        active: "Đang xử lý",
        resolved: "Đã giải quyết",
        cancelled: "Đã hủy",
        appealed: "Đang kháng cáo"
      },

      priority: {
        urgent: "Khẩn cấp",
        high: "Cao",
        medium: "Trung bình",
        low: "Thấp"
      },

      actions: {
        view: "Xem",
        edit: "Sửa",
        documents: "Tài liệu"
      },

      modal: {
        title: "Chi tiết tranh chấp",
        caseNumber: "Mã hồ sơ",
        status: "Trạng thái",
        plaintiff: "Nguyên đơn",
        defendant: "Bị đơn",
        startDate: "Ngày bắt đầu",
        resolveDate: "Ngày giải quyết",
        disputeType: "Loại tranh chấp",
        priority: "Mức độ ưu tiên",
        assignedTo: "Người phụ trách",
        description: "Mô tả",
        history: "Quá trình xử lý",
        noActivities: "Không có hoạt động nào được ghi nhận",
        close: "Đóng",
        edit: "Chỉnh sửa",
        updateStatus: "Cập nhật trạng thái"
      },

      noDisputesFound: "Không tìm thấy tranh chấp nào"
    },

    licenseRevocation: {
      title: "Thu Hồi Giấy Phép",
      subtitle: "Quản lý và thu hồi giấy phép sử dụng đối với các trường hợp vi phạm",
      search: "Tìm kiếm theo tên tác phẩm hoặc người được cấp phép...",

      filters: {
        allStatuses: "Tất cả trạng thái",
        active: "Đang hoạt động",
        pendingRevocation: "Chờ thu hồi",
        revoked: "Đã thu hồi"
      },

      table: {
        work: "Tác phẩm",
        licensee: "Người được cấp phép",
        licenseType: "Loại giấy phép",
        term: "Thời hạn",
        status: "Trạng thái",
        violations: "Vi phạm",
        actions: "Hành động"
      },

      licenseTypes: {
        basic: "Cơ bản",
        premium: "Cao cấp",
        enterprise: "Doanh nghiệp"
      },

      status: {
        active: "Đang hoạt động",
        pendingRevocation: "Chờ thu hồi",
        revoked: "Đã thu hồi"
      },

      term: {
        startDate: "Bắt đầu",
        endDate: "Kết thúc"
      },

      actions: {
        view: "Xem",
        revoke: "Thu hồi",
        undo: "Hoàn tác"
      },

      modal: {
        title: "Yêu cầu thu hồi giấy phép",
        requestingRevocation: "Bạn đang yêu cầu thu hồi giấy phép cho:",
        work: "Tác phẩm",
        licensee: "Người được cấp phép",
        violations: "Số vi phạm",
        reason: "Lý do thu hồi",
        reasonRequired: "Lý do thu hồi *",
        reasonPlaceholder: "Nhập lý do thu hồi giấy phép...",
        cancel: "Hủy",
        requestRevocation: "Yêu cầu thu hồi"
      },

      noLicensesFound: "Không tìm thấy giấy phép nào"
    },

    identityProtection: {
      title: "Bảo vệ danh tính",
      subtitle: "Quản lý và bảo vệ danh tính và nội dung của bạn khỏi các vi phạm và lạm dụng",

      overview: {
        overallScore: "Điểm bảo vệ tổng thể",
        protectionLevel: "Mức bảo vệ",
        identity: "Danh tính",
        content: "Nội dung",
        detection: "Phát hiện",
        currentAlerts: "Cảnh báo hiện tại",
        securityWeaknesses: "Điểm yếu bảo mật",
        safetyLevel: "Mức độ an toàn",
        issues: "vấn đề",
        safe: "An toàn",
        noWeaknesses: "Không phát hiện điểm yếu",
        allProtectionsMeasuresWorking: "Tất cả biện pháp bảo vệ đang hoạt động tốt",
        protectionStats: "Thống kê bảo vệ",
        worksProtected: "tác phẩm",
        beingProtected: "Đang được bảo vệ",
        certificatesIssued: "giấy chứng nhận",
        issuedOnBlockchain: "Đã cấp trên blockchain",
        violations: "vi phạm",
        resolved: "Đã được giải quyết",
        scans: "lần quét",
        inPast7Days: "Trong 7 ngày qua"
      },

      tabs: {
        overview: "Tổng quan",
        alerts: "Cảnh báo",
        measures: "Biện pháp bảo vệ",
        scan: "Quét phát hiện"
      },

      alerts: {
        highAlerts: "Cảnh báo cao",
        mediumAlerts: "Cảnh báo trung bình",
        lowAlerts: "Cảnh báo thấp",
        viewAllAlerts: "Xem tất cả cảnh báo",
        title: "Tất cả cảnh báo",
        filter: "Lọc",
        markAsRead: "Đánh dấu đã đọc",
        detected: "Phát hiện",
        platform: "Nền tảng",
        level: "Mức độ",
        viewDetails: "Xem chi tiết",
        handleNow: "Xử lý ngay",
        resolved: "Đã giải quyết"
      },

      measures: {
        identityProtectionMeasures: "Biện pháp bảo vệ danh tính",
        measures: "Biện pháp",
        status: "Trạng thái",
        effectiveness: "Hiệu quả",
        active: "Đang hoạt động",
        activate: "Kích hoạt",
        notActivated: "Chưa kích hoạt",
        manageMeasures: "Quản lý biện pháp bảo vệ",
        addNew: "Thêm biện pháp mới",
        description: "Mô tả",
        turnOff: "Tắt"
      },

      scan: {
        violationDetection: "Quét phát hiện vi phạm",
        scanInfo: "Hệ thống sẽ tự động quét trên các nền tảng để phát hiện vi phạm bản quyền và danh tính. Bạn cũng có thể chạy quét thủ công bất cứ lúc nào.",
        lastScan: "Lần quét gần nhất",
        quickScan: "Quét nhanh",
        quickScanDesc: "Quét trên các nền tảng phổ biến để phát hiện các vi phạm mới",
        startQuickScan: "Bắt đầu quét nhanh",
        comprehensiveScan: "Quét toàn diện",
        comprehensiveScanDesc: "Quét sâu trên nhiều nền tảng và trang web (có thể mất nhiều thời gian)",
        startComprehensiveScan: "Bắt đầu quét toàn diện",
        scanOptions: "Tùy chọn quét",
        socialMedia: "Mạng xã hội (Facebook, Instagram, TikTok...)",
        videoSites: "Trang video (YouTube, Vimeo...)",
        ecommerce: "Trang thương mại điện tử",
        blogs: "Blog và trang tin tức",
        deepfake: "Phát hiện deepfake",
        impersonation: "Tìm tài khoản giả mạo",
        scanHistory: "Lịch sử quét",
        date: "Ngày",
        type: "Loại",
        results: "Kết quả",
        violations: "vi phạm",
        autoScanConfig: "Cấu hình quét tự động",
        scanFrequency: "Tần suất quét",
        daily: "Hàng ngày",
        weekly: "Hàng tuần",
        biweekly: "Hai tuần một lần",
        monthly: "Hàng tháng",
        scanTime: "Thời gian quét",
        morning: "Buổi sáng (8:00)",
        afternoon: "Buổi chiều (14:00)",
        night: "Buổi tối (22:00)",
        autoSendTakedown: "Tự động gửi yêu cầu gỡ bỏ nội dung vi phạm",
        saveConfig: "Lưu cấu hình"
      },

      tips: {
        identityProtectionTips: "Mẹo bảo vệ danh tính",
        updateWorks: "Cập nhật tác phẩm thường xuyên",
        updateWorksDesc: "Cập nhật metadata và thông tin tác phẩm giúp cải thiện khả năng nhận diện và ngăn chặn vi phạm.",
        activateAllMeasures: "Kích hoạt tất cả biện pháp bảo vệ",
        activateAllMeasuresDesc: "Kích hoạt đầy đủ các biện pháp bảo vệ giúp tăng cường an toàn cho tác phẩm và danh tính của bạn.",
        checkAlertsRegularly: "Kiểm tra cảnh báo thường xuyên",
        checkAlertsRegularlyDesc: "Xử lý kịp thời các cảnh báo giúp hạn chế tác động của vi phạm bản quyền và danh tính."
      }
    },

    aiScan: {
      title: "Quét và phát hiện vi phạm bằng AI",
      subtitle: "Sử dụng AI để quét và phát hiện vi phạm bản quyền trên các nền tảng số",

      stats: {
        aiModelInUse: "Mô hình AI đang dùng",
        accuracy: "Độ chính xác",
        configure: "Cấu hình",
        lastScan: "Lần quét gần nhất",
        totalScans: "Tổng số lần quét",
        totalViolationsDetected: "Tổng vi phạm phát hiện",
        avgScanTime: "Thời gian quét trung bình",
        minutes: "phút"
      },

      newScan: {
        startNewScan: "Bắt đầu quét mới",
        scanning: "Đang quét...",
        scanNote: "Quá trình quét có thể mất từ vài phút đến vài giờ tùy thuộc vào số lượng tác phẩm và cài đặt quét.",
        scanCompleted: "Quét hoàn tất!",
        scanCompletedMessage: "Quá trình quét đã hoàn tất, phát hiện {count} vi phạm tiềm ẩn.",
        scanAgain: "Quét lại",

        scanPlatform: "Nền tảng quét",
        allPlatforms: "Tất cả nền tảng",
        facebook: "Facebook",
        youtube: "YouTube",
        instagram: "Instagram",
        tiktok: "TikTok",
        websites: "Websites",

        scanDepth: "Mức độ quét",
        quick: "Quét nhanh (ít chính xác hơn)",
        standard: "Tiêu chuẩn (cân bằng thời gian và độ chính xác)",
        deep: "Quét sâu (chính xác nhất, nhưng mất nhiều thời gian)",

        violationType: "Loại vi phạm",
        allViolationTypes: "Tất cả loại vi phạm",
        unauthorizedUsage: "Sử dụng trái phép",
        deepfake: "Deepfake",
        impersonation: "Mạo danh",
        contractViolation: "Vi phạm hợp đồng",

        additionalOptions: "Tùy chọn bổ sung",
        enableDeepfake: "Bật phát hiện deepfake",
        enableImpersonation: "Bật phát hiện mạo danh danh tính",

        startScan: "Bắt đầu quét"
      },

      detectionResults: {
        title: "Kết quả phát hiện",
        filter: "Lọc",
        exportReport: "Xuất báo cáo",
        downloadCsv: "Tải về CSV",
        work: "Tác phẩm",
        platform: "Nền tảng",
        violationType: "Loại vi phạm",
        severity: "Mức độ",
        similarity: "Độ tương đồng",
        detectionTime: "Thời gian phát hiện",
        actions: "Thao tác",
        view: "Xem",
        report: "Báo cáo"
      },

      aiModels: {
        availableModels: "Mô hình AI có sẵn",
        modelName: "Tên mô hình",
        accuracy: "Độ chính xác",
        lastUpdate: "Cập nhật lần cuối",
        status: "Trạng thái",
        active: "Hoạt động",
        inactive: "Không hoạt động",
        inUse: "Đang dùng",
        select: "Chọn"
      },

      autoScan: {
        schedule: "Lịch quét tự động",
        frequency: "Tần suất quét",
        daily: "Hàng ngày",
        weekly: "Hàng tuần",
        biweekly: "Hai tuần một lần",
        monthly: "Hàng tháng",
        scanDepth: "Mức độ quét",
        dayOfWeek: "Ngày trong tuần",
        monday: "Thứ Hai",
        tuesday: "Thứ Ba",
        wednesday: "Thứ Tư",
        thursday: "Thứ Năm",
        friday: "Thứ Sáu",
        saturday: "Thứ Bảy",
        sunday: "Chủ Nhật",
        time: "Thời gian",
        timeHint: "Nên chọn thời gian ít tải trọng hệ thống",
        sendNotification: "Gửi thông báo khi phát hiện vi phạm",
        autoCreateReport: "Tự động tạo báo cáo vi phạm",
        updateSchedule: "Cập nhật lịch quét"
      },

      guide: {
        title: "Hướng dẫn",
        manualVsAuto: "Quét thủ công vs. Lịch trình tự động",
        manualVsAutoDesc: "Quét thủ công cho phép bạn kiểm soát nhiều hơn, trong khi lịch trình tự động giúp giám sát liên tục.",
        scanDepth: "Mức độ quét",
        scanDepthDesc: "Quét sâu mang lại kết quả chính xác nhất nhưng sẽ mất nhiều thời gian hơn. Quét nhanh thích hợp cho kiểm tra hàng ngày.",
        processingResults: "Xử lý kết quả",
        processingResultsDesc: "Bạn nên xem xét kỹ từng vi phạm được phát hiện để đảm bảo tính chính xác trước khi thực hiện các hành động pháp lý."
      }
    },

    system: {
      title: "Quản trị hệ thống",
      subtitle: "Cấu hình và giám sát hệ thống Vietrro",

      dashboard: {
        serverStatus: "Trạng thái máy chủ",
        lastUpdate: "Cập nhật gần nhất",
        online: "Online",
        offline: "Offline",
        uptime: "Thời gian hoạt động",
        dataBackup: "Sao lưu dữ liệu",
        apiRequests: "API Requests",
        today: "Requests trong ngày hôm nay",
        activeUsers: "Người dùng đang hoạt động",
        onlineUsers: "Người dùng đang trực tuyến"
      },

      resources: {
        title: "System Resources",
        cpuUsage: "CPU Usage",
        memoryUsage: "Memory Usage",
        diskUsage: "Disk Usage"
      },

      services: {
        title: "Service Status",
        webServer: "Web Server",
        database: "Database",
        apiService: "API Service",
        emailService: "Email Service",
        backupService: "Backup Service",
        aiDetection: "AI Detection"
      },

      backups: {
        title: "Quản lý sao lưu",
        recentBackups: "Sao lưu gần đây",
        createBackup: "Tạo sao lưu mới",
        backupId: "ID",
        name: "Tên",
        time: "Thời gian",
        size: "Kích thước",
        status: "Trạng thái",
        actions: "Thao tác",
        download: "Tải về",
        newBackup: "Tạo sao lưu mới",
        backupType: "Loại sao lưu",
        fullBackup: "Sao lưu toàn bộ",
        databaseOnly: "Chỉ sao lưu cơ sở dữ liệu",
        filesOnly: "Chỉ sao lưu tệp tin",
        userData: "Dữ liệu người dùng",
        description: "Mô tả",
        backupInProgress: "Đang tạo sao lưu. Vui lòng đợi...",
        cancel: "Hủy bỏ",
        processing: "Đang xử lý..."
      },

      settings: {
        title: "Cài đặt hệ thống",
        general: "Cài đặt chung",
        systemName: "Tên hệ thống",
        adminEmail: "Admin Email",
        sessionTimeout: "Thời gian session timeout (phút)",
        defaultLanguage: "Ngôn ngữ mặc định",
        vietnamese: "Tiếng Việt",
        english: "English",
        security: "Cài đặt an ninh",
        require2FA: "Yêu cầu xác thực 2 lớp cho admin",
        yes: "Có",
        no: "Không",
        minPasswordLength: "Độ dài mật khẩu tối thiểu",
        maxLoginAttempts: "Số lần đăng nhập sai tối đa",
        accountLockTime: "Thời gian khóa tài khoản (phút)",
        saveSettings: "Lưu cài đặt"
      },

      logs: {
        title: "Nhật ký hệ thống",
        all: "Tất cả nhật ký",
        error: "Lỗi",
        warning: "Cảnh báo",
        info: "Thông tin",
        time: "Thời gian",
        level: "Mức độ",
        module: "Module",
        content: "Nội dung",
        ip: "IP",
        exportLogs: "Xuất nhật ký",
        previous: "Previous",
        next: "Next"
      }
    },

    apiManagement: {
      title: "Quản lý API",
      subtitle: "Quản lý khóa API và theo dõi lượng sử dụng",
      createKey: "Tạo khóa API",
      search: "Tìm kiếm...",

      tabs: {
        keys: "Khóa API",
        usage: "Lượng sử dụng"
      },

      keysTable: {
        name: "Tên",
        key: "Khóa API",
        creator: "Người tạo",
        status: "Trạng thái",
        created: "Ngày tạo",
        expires: "Ngày hết hạn",
        lastUsed: "Sử dụng gần đây",
        actions: "Thao tác"
      },

      usageTable: {
        date: "Ngày",
        apiKey: "Khóa API",
        requests: "Requests",
        success: "Thành công",
        errors: "Lỗi",
        responseTime: "Thời gian phản hồi (ms)",
        dataTransferred: "Dữ liệu truyền (MB)"
      },

      status: {
        active: "Đang hoạt động",
        inactive: "Không hoạt động",
        revoked: "Đã thu hồi"
      },

      filter: {
        today: "Ngày hôm nay",
        yesterday: "Ngày hôm qua",
        last7Days: "7 ngày qua",
        last30Days: "30 ngày qua",
        allApiKeys: "Tất cả khóa API"
      },

      modal: {
        createNewKey: "Tạo khóa API mới",
        editKey: "Chỉnh sửa khóa API",
        revokeKey: "Thu hồi khóa API",
        warning: "Cảnh báo!",
        revokeWarning: "Bạn đang chuẩn bị thu hồi khóa API",
        irreversibleAction: "Hành động này không thể hoàn tác và sẽ làm cho tất cả các yêu cầu sử dụng khóa này không hoạt động.",
        confirmContinue: "Bạn có chắc chắn muốn tiếp tục?",
        keyCreated: "Khóa API của bạn đã được tạo thành công!",
        saveKeyWarning: "Đây là lần duy nhất khóa API của bạn được hiển thị. Hãy lưu lại ngay.",
        keySaved: "Tôi đã lưu khóa API",

        form: {
          keyName: "Tên khóa API",
          keyNameHelp: "Đặt tên để dễ dàng nhận biết mục đích sử dụng của khóa API này",
          requestLimit: "Hạn mức request",
          term: "Thời hạn",
          days30: "30 ngày",
          days90: "90 ngày",
          days180: "180 ngày",
          year1: "1 năm",
          year2: "2 năm",
          accessPermissions: "Quyền truy cập",
          readPermission: "Quyền đọc (GET)",
          createPermission: "Quyền tạo mới (POST)",
          updatePermission: "Quyền cập nhật (PUT/PATCH)",
          deletePermission: "Quyền xóa (DELETE)",
          notes: "Ghi chú (tùy chọn)",
          cancel: "Hủy bỏ",
          create: "Tạo khóa API",
          update: "Cập nhật",
          revoke: "Thu hồi khóa API"
        }
      },

      info: {
        title: "Thông tin API",
        securityWarning: "Khóa API là bí mật và không nên được chia sẻ công khai. Hãy bảo vệ khóa API của bạn như bảo vệ mật khẩu.",
        description: "API của Vietrro cho phép bạn tích hợp các tính năng quản lý bản quyền vào ứng dụng của mình.",
        documentation: "Tài liệu API đầy đủ có sẵn tại",
        viewDocs: "Xem tài liệu API"
      },

      limits: {
        title: "Giới hạn sử dụng",
        packageLimits: "Giới hạn theo gói",
        basic: "Gói Basic",
        professional: "Gói Professional",
        enterprise: "Gói Enterprise",
        requestsPerDay: "requests/ngày",
        currentUsage: "Lượng sử dụng hiện tại",
        today: "Hôm nay"
      }
    },

    admin: {
      permissions: {
        title: "Quản lý người dùng & phân quyền",
        subtitle: "Quản lý tài khoản người dùng và phân quyền hệ thống",
        search: "Tìm kiếm...",
        addUser: "Thêm người dùng",

        tabs: {
          users: "Người dùng",
          roles: "Vai trò & quyền"
        },

        userTable: {
          id: "ID",
          name: "Tên",
          email: "Email",
          role: "Vai trò",
          status: "Trạng thái",
          created: "Ngày tạo",
          lastLogin: "Đăng nhập gần nhất",
          actions: "Thao tác"
        },

        roleTable: {
          id: "ID",
          roleName: "Tên vai trò",
          description: "Mô tả",
          userCount: "Số người dùng",
          permissions: "Quyền hạn",
          actions: "Thao tác"
        },

        status: {
          active: "Đang hoạt động",
          inactive: "Không hoạt động",
          suspended: "Đã khóa"
        },

        roles: {
          admin: "Quản trị viên",
          staff: "Nhân viên",
          right_owner: "Chủ sở hữu",
          licensee: "Người mua",
          legal: "Pháp lý",
          monitor: "Giám sát"
        },

        overview: {
          title: "Tổng quan người dùng",
          totalUsers: "Tổng số người dùng",
          active: "Đang hoạt động",
          inactive: "Không hoạt động",
          newUsers: "Người dùng mới (30 ngày qua)"
        },

        distribution: {
          title: "Phân bố người dùng theo vai trò",
          users: "người dùng"
        },

        modal: {
          addUser: "Thêm người dùng mới",
          editUser: "Chỉnh sửa người dùng",
          addRole: "Thêm vai trò mới",
          editRole: "Chỉnh sửa vai trò",

          form: {
            fullName: "Họ tên",
            email: "Email",
            role: "Vai trò",
            selectRole: "-- Chọn vai trò --",
            status: "Trạng thái",
            active: "Đang hoạt động",
            inactive: "Không hoạt động",
            suspended: "Khóa tài khoản",
            password: "Mật khẩu",
            confirmPassword: "Xác nhận mật khẩu",
            notes: "Ghi chú",
            roleName: "Tên vai trò (hiển thị)",
            systemName: "Tên vai trò (hệ thống)",
            systemNameHelp: "Chỉ sử dụng chữ thường, không dấu và dấu gạch dưới",
            description: "Mô tả",
            systemPermissions: "Quyền hệ thống",
            allPermissions: "Tất cả quyền (Admin)",
            contentManagement: "Quản lý nội dung",
            userManagement: "Quản lý người dùng",
            licenseManagement: "Quản lý bản quyền",
            legalManagement: "Quản lý pháp lý",
            monitoringReporting: "Giám sát và Báo cáo",
            others: "Khác",
            cancel: "Hủy bỏ",
            add: "Thêm",
            update: "Cập nhật"
          }
        }
      },

      logs: {
        title: "Nhật ký hoạt động hệ thống",
        subtitle: "Xem và quản lý các nhật ký hoạt động của hệ thống",
        search: "Tìm kiếm theo nội dung, người dùng...",

        filters: {
          allLevels: "Tất cả mức độ",
          error: "Error",
          warning: "Warning",
          info: "Info",
          debug: "Debug",
          allModules: "Tất cả module"
        },

        actions: {
          filter: "Lọc",
          export: "Xuất"
        },

        table: {
          id: "ID",
          timestamp: "Thời gian",
          level: "Mức độ",
          module: "Module",
          user: "Người dùng",
          action: "Nội dung",
          ip: "IP",
          actions: "Thao tác"
        },

        loading: "Đang tải dữ liệu...",
        noLogsFound: "Không tìm thấy nhật ký nào phù hợp",
        noLogs: "Chưa có nhật ký nào",

        summary: {
          title: "Tổng quan nhật ký",
          totalLogs: "Tổng số nhật ký",
          errors: "Lỗi",
          warnings: "Cảnh báo",
          info: "Thông tin"
        },

        management: {
          title: "Quản lý nhật ký",
          description: "Các nhật ký hệ thống được lưu trữ trong thời gian nhất định để phục vụ mục đích kiểm tra và khắc phục sự cố.",
          downloadLogs: "Tải nhật ký",
          deleteOldLogs: "Xóa nhật ký cũ"
        }
      }
    },

    licensePurchase: {
      title: "Mua giấy phép sử dụng",
      subtitle: "Chọn và mua giấy phép sử dụng tác phẩm phù hợp với nhu cầu của bạn",

      workInfo: {
        title: "Thông tin tác phẩm",
        author: "Tác giả",
        type: "Loại",
        category: "Danh mục",
        rating: "Đánh giá",
        purchases: "Lượt mua",
        imageCount: "Số lượng hình ảnh",
        formats: "Định dạng",
        resolution: "Độ phân giải",
        createdDate: "Ngày tạo"
      },

      license: {
        chooseLicense: "Chọn giấy phép",
        licenseType: "Loại giấy phép",
        licenseTerm: "Thời hạn giấy phép",
        agreement: "Tôi đồng ý với",
        termsAndConditions: "các điều khoản và điều kiện",
        ofLicense: "của giấy phép sử dụng",
        buyLicense: "Mua giấy phép"
      },

      payment: {
        title: "Thông tin thanh toán",
        licenseType: "Loại giấy phép",
        term: "Thời hạn",
        licensePrice: "Giá giấy phép",
        vat: "Thuế VAT (10%)",
        totalPayment: "Tổng thanh toán",
        paymentMethod: "Phương thức thanh toán",
        creditCard: "Thẻ tín dụng / Thẻ ghi nợ",
        bankTransfer: "Chuyển khoản ngân hàng",
        support: "Hỗ trợ",
        supportText: "Nếu bạn cần hỗ trợ hoặc có thắc mắc về giấy phép, vui lòng liên hệ với chúng tôi.",
        requestSupport: "Yêu cầu hỗ trợ"
      },

      important: {
        title: "Lưu ý quan trọng",
        notice: "Giấy phép sẽ có hiệu lực ngay sau khi thanh toán hoàn tất. Bạn có thể tải tác phẩm và bắt đầu sử dụng ngay lập tức."
      },

      termsModal: {
        title: "Điều khoản và điều kiện giấy phép",
        licenseTerms: "Giấy phép sử dụng nội dung Vietrro",
        termsAgreement: "Bằng việc mua và sử dụng giấy phép, bạn đồng ý với các điều khoản và điều kiện sau:",
        scope: "Phạm vi sử dụng",
        scopeDesc: "Phạm vi sử dụng phụ thuộc vào loại giấy phép mà bạn chọn. Mỗi loại giấy phép có những quyền và giới hạn khác nhau. Bạn chỉ được phép sử dụng tác phẩm trong phạm vi được quy định trong giấy phép.",
        term: "Thời hạn",
        termDesc: "Giấy phép có hiệu lực trong khoảng thời gian được chỉ định kể từ ngày mua. Sau khi hết hạn, bạn phải ngừng sử dụng tác phẩm hoặc gia hạn giấy phép.",
        intellectualProperty: "Sở hữu trí tuệ",
        ipDesc: "Tác giả giữ quyền sở hữu trí tuệ đối với tác phẩm. Giấy phép chỉ cấp quyền sử dụng, không chuyển quyền sở hữu.",
        attribution: "Quy định về ghi nhận tác giả",
        attributionDesc: "Trừ khi được quy định khác trong giấy phép, bạn phải ghi nhận tên tác giả và nguồn gốc của tác phẩm khi sử dụng.",
        restrictions: "Hạn chế",
        restrictionsDesc: "Bạn không được sao chép, phân phối lại, bán lại, cho thuê, hoặc chuyển nhượng giấy phép hoặc tác phẩm cho bên thứ ba, trừ khi được quy định cụ thể trong giấy phép.",
        termination: "Chấm dứt",
        terminationDesc: "Giấy phép sẽ tự động chấm dứt nếu bạn vi phạm bất kỳ điều khoản nào. Trong trường hợp này, bạn phải ngừng sử dụng tác phẩm ngay lập tức.",
        indemnification: "Bồi thường",
        indemnificationDesc: "Bạn đồng ý bồi thường cho tác giả và Vietrro trong trường hợp có thiệt hại phát sinh từ việc sử dụng tác phẩm sai quy định.",
        agree: "Tôi đồng ý"
      },

      successModal: {
        title: "Mua giấy phép thành công",
        thankYou: "Cảm ơn bạn đã mua giấy phép!",
        successMessage: "Giao dịch đã được xử lý thành công. Giấy phép của bạn đã được kích hoạt.",
        licenseCode: "Mã giấy phép",
        downloadWork: "Tải tác phẩm",
        viewLicense: "Xem giấy phép"
      }
    }
  }
};